import { attachEmailValidatorToForm } from "../../shared/emailFieldValidator";
import { attachPhoneValidatorToForm } from "../../shared/phoneFieldValidator";
if (!window.wp || !window.wp.i18n) {
    window.wp = {
        i18n: {
            __: (text) => text, // Simple translation function
        },
    };
}
const { __ } = window.wp.i18n;
class Form {
    constructor(defaultFormId, formEl, eventId) {
        var _a;
        this._responseWrapper = null;
        this._formMode = "default";
        this._formEl = formEl;
        this._instance = null;
        this._eventId = eventId;
        this._userData = {};
        this._defaultFormId = defaultFormId;
        if (document.getElementById("horaEventRegisterModal")) {
            this._formMode = "modal";
        }
        this._submitBtn =
            (_a = this._formEl.querySelector(".hora-event-register-btn")) !== null && _a !== void 0 ? _a : this._formEl.querySelector('button[type="submit"]');
        this._init();
    }
    _init() {
        this.bindEvents();
    }
    bindEvents() {
        jQuery(this._formEl).on("submit", (event) => {
            event.preventDefault();
            this.submit();
        });
        attachEmailValidatorToForm(this._formEl, {
            restUrl: window.hora_events.rest_url,
            nonce: window.hora_events.rest_nonce,
        });
        attachPhoneValidatorToForm(this._formEl, {
            restUrl: window.hora_events.rest_url,
            nonce: window.hora_events.rest_nonce,
        });
    }
    submit() {
        var _a, _b, _c, _d;
        if ((_a = this._options) === null || _a === void 0 ? void 0 : _a.onSubmit) {
            this._options.onSubmit(this._formEl);
        }
        (_b = this._responseWrapper) === null || _b === void 0 ? void 0 : _b.remove();
        if (!this._formEl.checkValidity()) {
            this._formEl.reportValidity();
            return;
        }
        (_c = this._submitBtn) === null || _c === void 0 ? void 0 : _c.setAttribute("disabled", "disabled");
        (_d = this._submitBtn) === null || _d === void 0 ? void 0 : _d.insertAdjacentHTML("beforeend", '<span class="hora-spinner" role="status"></span>');
        const formData = window.parseFormData(this._formEl);
        const data = {
            action: "hora_event_apply",
            event_id: this._eventId,
            nonce: window.hora_events.nonce,
        };
        jQuery
            .ajax({
            url: window.hora_events.ajax_url,
            type: "POST",
            data: formData + "&" + jQuery.param(data),
            dataType: "json",
            success: this._handleSuccess.bind(this),
            error: this._handleError.bind(this),
        })
            .always(() => {
            var _a, _b;
            (_a = this._submitBtn) === null || _a === void 0 ? void 0 : _a.removeAttribute("disabled");
            const spinner = (_b = this._submitBtn) === null || _b === void 0 ? void 0 : _b.querySelector(".hora-spinner");
            if (spinner) {
                spinner.remove();
            }
        });
    }
    _handleSuccess(response) {
        const successMessage = this._formEl.getAttribute("data-success-message");
        const errorMessage = this._formEl.getAttribute("data-error-message");
        if (response.success) {
            this._formEl.reset();
            this._initResponseWrapper("success");
            this._responseWrapper.innerHTML = `<div class="hora-success">${successMessage || "Your application has been submitted successfully."}</div>`;
        }
        else {
            this._initResponseWrapper();
            this._responseWrapper.innerHTML = `<div class="hora-error">${response.data.message ||
                errorMessage ||
                "There was an error submitting your application. Please try again."}</div>`;
        }
    }
    _handleError(jqXHR, textStatus, errorThrown) {
        console.error("Error submitting form:", textStatus, errorThrown);
        alert(__("An error occurred while submitting the form. Please try again later.", "hora-events"));
    }
    _initResponseWrapper(type = "error") {
        if (!this._responseWrapper) {
            this._responseWrapper = document.createElement("div");
            this._responseWrapper.className = `hora-response-wrapper hora-response-${type}`;
            this._formEl.insertAdjacentElement("beforeend", this._responseWrapper);
        }
    }
    updateOnSubmit(callback) {
        this._options.onSubmit = callback;
    }
    getUserData() {
        this._userData = this._instance.userData;
        return this._userData;
    }
    clear() {
        var _a;
        this._formEl.reset();
        this._userData = {};
        (_a = this._responseWrapper) === null || _a === void 0 ? void 0 : _a.remove();
        this._responseWrapper = null;
    }
}
export function initForms() {
    document
        .querySelectorAll("form[data-event-register-form]")
        .forEach(($form) => {
        const formEl = $form;
        if (!formEl || !(formEl instanceof HTMLFormElement)) {
            console.error("No form element found or invalid form element");
            return;
        }
        const eventId = formEl.getAttribute("data-event-id");
        const defaultFormId = formEl.id;
        new Form(defaultFormId, formEl, eventId || "");
    });
}
